import { registerServiceWorker } from '@/lib/sw-register';

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    registerServiceWorker();
    // PWA initialized successfully
  } else {
    navigator.serviceWorker.getRegistrations().then(registrations => {
      registrations.forEach(registration => registration.unregister());
    });
  }
}

import '@/app/index';

export {};
